import React from "react";
import { Route } from "react-router-dom";
import Signin from "../components/auth/Signin";

const AuthRoutes = () => {
  return <Route path="/login" element={<Signin />} />;
};

export default AuthRoutes;
